export default __webpack_public_path__ + "static/media/MINUTES OF ANNUAL SHAREHOLDERS MEETING 20 April 2022.6104dea7.pdf";